import React from 'react';
import { auth } from '../firebaseConfig';
import { signOut } from 'firebase/auth';

const Navbar = ({ user }) => {
  const handleLogout = async () => {
    try {
      sessionStorage.removeItem('googleAccessToken');
      await signOut(auth);
      window.location.href = '/';
    } catch (error) {
      console.error("Errore durante il logout:", error);
    }
  };

  return (
    <nav className="bg-white shadow-md">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <a href="/" className="text-xl font-bold text-gray-800">ToDo App</a>
        {user && (
          <div className="flex items-center">
            <span className="text-gray-700 mr-4">Ciao, {user.displayName}</span>
            <button
              onClick={handleLogout}
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded-lg"
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;